import Typography from '@mui/material/Typography';
import { memo } from 'react';

import styles from './PreviewCountdownPill.module.scss';

const PreviewCountdownPill = ({ secondsRemaining }: { secondsRemaining: number }) => (
  <div className={styles.previewCountdownPill} data-testid="preview-countdown-pill">
    <span className={styles.liveIndicator}>
      <span className={styles.liveDot} />
      <Typography variant="overline3" component="span">
        LIVE
      </Typography>
    </span>
    <Typography variant="overline3" component="span">
      Preview ends in 0:{String(secondsRemaining).padStart(2, '0')}
    </Typography>
  </div>
);

export default memo(PreviewCountdownPill);
